import ClientCard from "./client-card";

export default ClientCard;
